(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('AppAttestLogController', AppAttestLogController);

    AppAttestLogController.$inject = ['$state', 'DataUtils', 'AppAttestLog', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function AppAttestLogController($state, DataUtils, AppAttestLog, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        vm.searchQuery = {
            phone: pagingParams.phone,
            status: pagingParams.status,
            endpoint: pagingParams.endpoint,
            errorCode: pagingParams.errorCode,
            fromDate: pagingParams.fromDate,
            toDate: pagingParams.toDate,
            from: pagingParams.from,
            to: pagingParams.to
        };

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus.from = false;
        vm.datePickerOpenStatus.to = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function getDateTimeFromPicker() {
            $('.input-daterange input').each(function () {
                if ($(this).attr('name') == 'from') {
                    vm.searchQuery.fromDate = $(this).val();
                } else if ($(this).attr('name') == 'to') {
                    vm.searchQuery.toDate = $(this).val();
                }
            });
        }

        function initDatePicker() {
            if (vm.searchQuery.toDate === null) {
                vm.searchQuery.to = new Date();
                pagingParams.toDate = vm.searchQuery.to;
            }
            if (vm.searchQuery.fromDate === null) {
                vm.searchQuery.from = new Date();
                vm.searchQuery.from.setMonth(vm.searchQuery.from.getMonth() - 1);
                pagingParams.fromDate = vm.searchQuery.from;
            }
            $('.input-daterange input').each(function () {
                if ($(this).attr('name') == 'from') {
                    $(this).val(vm.searchQuery.from);
                } else if ($(this).attr('name') == 'to') {
                    $(this).val(vm.searchQuery.to);
                }
            });

            $('.date-picker').datepicker({autoclose: true});
        }

        function search() {
            getDateTimeFromPicker();
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.searchQuery = {
                phone: null,
                endpoint: null,
                errorCode: null,
                status: null,
                fromDate: null,
                toDate: null,
                from: null,
                to: null
            };
            initDatePicker();
            vm.transition();
        }

        initDatePicker();
        loadAll();

        function loadAll() {
            getDateTimeFromPicker();
            AppAttestLog.query({
                phone: vm.searchQuery.phone,
                status: vm.searchQuery.status,
                endpoint: vm.searchQuery.endpoint,
                errorCode: vm.searchQuery.errorCode,
                fromDate: vm.searchQuery.fromDate,
                toDate: vm.searchQuery.toDate,
                from: vm.searchQuery.from,
                to: vm.searchQuery.to,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.appAttestLogs = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                phone: vm.searchQuery.phone,
                status: vm.searchQuery.status,
                endpoint: vm.searchQuery.endpoint,
                errorCode: vm.searchQuery.errorCode,
                fromDate: vm.searchQuery.fromDate,
                toDate: vm.searchQuery.toDate,
                from: vm.searchQuery.from,
                to: vm.searchQuery.to,
                search: vm.currentSearch
            });
        }

        loadAll();
    }
})();
